export const Emoticon = ({ width, height, viewBox, styles }) => {
  return (
    <svg
      width={width || '40'}
      height={height || '40'}
      viewBox={viewBox || '0 0 40 40'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles}
    >
      <path
        d="M23.182 23.182C21.4246 24.9393 18.5754 24.9393 16.818 23.182M29 20C29 24.9706 24.9706 29 20 29C15.0294 29 11 24.9706 11 20C11 15.0294 15.0294 11 20 11C24.9706 11 29 15.0294 29 20ZM17.75 17.75C17.75 18.1642 17.5821 18.5 17.375 18.5C17.1679 18.5 17 18.1642 17 17.75C17 17.3358 17.1679 17 17.375 17C17.5821 17 17.75 17.3358 17.75 17.75ZM17.375 17.75H17.3825V17.765H17.375V17.75ZM23 17.75C23 18.1642 22.8321 18.5 22.625 18.5C22.4179 18.5 22.25 18.1642 22.25 17.75C22.25 17.3358 22.4179 17 22.625 17C22.8321 17 23 17.3358 23 17.75ZM22.625 17.75H22.6325V17.765H22.625V17.75Z"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
